import React from 'react';

const isPositive = (val) => {
    if (!val) return false;
    const str = String(val).trim().toUpperCase();
    return str === "SI" || str === "YES" || str === "1" || str === "ATTIVO" || str === "DISPONIBILE" || str.includes("OK");
};

const renderBoolBadge = (params, label) => {
    const active = isPositive(params.value);
    return (
        <span style={{
            padding: '3px 10px',
            borderRadius: '12px',
            fontSize: '0.75rem',
            fontWeight: 'bold',
            backgroundColor: active ? 'rgba(16, 185, 129, 0.15)' : 'rgba(148, 163, 184, 0.1)',
            color: active ? '#10b981' : '#94a3b8',
            border: `1px solid ${active ? 'rgba(16, 185, 129, 0.3)' : 'rgba(148, 163, 184, 0.2)'}`
        }}>
            {active ? `✓ ${label || 'SI'}` : 'NO'}
        </span>
    );
};

const renderStatusBuilding = (params) => {
    if (!params.value) return '-';
    return (
        <span style={{
            padding: '3px 10px',
            borderRadius: '12px',
            fontSize: '0.75rem',
            fontWeight: 'bold',
            backgroundColor: 'rgba(255, 15, 100, 0.1)',
            color: '#ff0f64',
            border: '1px solid rgba(255, 15, 100, 0.2)'
        }}>
            {params.value}
        </span>
    );
};

const ColumnsUnidata = [
    { field: 'id', headerName: 'ID', width: 80, sortable: false },
    { field: 'tipo', headerName: 'Tipo', width: 90, sortable: false },
    { field: 'id_scala', headerName: 'ID Scala', width: 110, sortable: false },
    { field: 'regione', headerName: 'Regione', width: 100, sortable: false },
    { field: 'provincia', headerName: 'Provincia', width: 90, sortable: false },
    { field: 'comune', headerName: 'Comune', width: 130, sortable: false },
    { field: 'comune_descrizione', headerName: 'Descrizione Comune', width: 180, sortable: false },
    { field: 'frazione', headerName: 'Frazione', width: 130, sortable: false },
    { field: 'particella_top', headerName: 'Particella', width: 100, sortable: false },
    { field: 'indirizzo', headerName: 'Via/Indirizzo', width: 200, sortable: false },
    { field: 'civico', headerName: 'Civico', width: 80, sortable: false },
    { field: 'scala_palazzina', headerName: 'Scala/Palazzina', width: 120, sortable: false },
    { field: 'codice_via', headerName: 'Codice Via', width: 110, sortable: false },
    { field: 'id_building', headerName: 'ID Building', width: 130, sortable: false },
    { field: 'pop', headerName: 'POP', width: 120, sortable: false },
    { field: 'totale_ui', headerName: 'Totale UI', width: 90, sortable: false },
    { field: 'stato_building', headerName: 'Stato Building', width: 140, sortable: false, renderCell: renderStatusBuilding },
    { field: 'egon_civico', headerName: 'EGON Civico', width: 110, sortable: false },
    { field: 'egon_strada', headerName: 'EGON Strada', width: 110, sortable: false },
    { field: 'gpon', headerName: 'GPON', width: 100, sortable: false, renderCell: (p) => renderBoolBadge(p, 'GPON') },
    { field: 'ftth', headerName: 'FTTH', width: 100, sortable: false, renderCell: (p) => renderBoolBadge(p, 'FTTH') },
    { field: 'pt_1000', headerName: 'PT 1000', width: 100, sortable: false, renderCell: (p) => renderBoolBadge(p, '1 Gbps') },
    { field: 'pt_2500', headerName: 'PT 2500', width: 100, sortable: false, renderCell: (p) => renderBoolBadge(p, '2.5 Gbps') },
    { field: 'pt_10g', headerName: 'PT 10G', width: 110, sortable: false, renderCell: (p) => renderBoolBadge(p, '10 Gbps') },
    { field: 'geo_lat', headerName: 'Latitudine', width: 110, sortable: false },
    { field: 'geo_lon', headerName: 'Longitudine', width: 110, sortable: false },
    { field: 'master_slave', headerName: 'Master/Slave', width: 110, sortable: false },
    { field: 'pfs', headerName: 'PFS', width: 120, sortable: false },
    { field: 'pte', headerName: 'PTE', width: 120, sortable: false },
    { field: 'id_zona', headerName: 'ID Zona', width: 100, sortable: false },
    { field: 'denom_zona', headerName: 'Denominazione Zona', width: 180, sortable: false },
];

export default ColumnsUnidata;